import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import tgApi from '../../utils/tgApi';

export const fetchMembers = createAsyncThunk(
  'members/fetchMembers',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await tgApi.getMembers(params);
      return data;
    } catch (err) {
      const detail = err.response?.data?.detail;
      const msg = Array.isArray(detail) ? detail.map(d => d.msg || JSON.stringify(d)).join(', ') : (typeof detail === 'string' ? detail : '회원 목록을 불러올 수 없습니다.');
      return rejectWithValue(msg);
    }
  }
);

export const deleteMember = createAsyncThunk(
  'members/deleteMember',
  async (id, { rejectWithValue }) => {
    try {
      await tgApi.deleteMember(id);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || '회원 삭제에 실패했습니다.');
    }
  }
);

const membersSlice = createSlice({
  name: 'members',
  initialState: {
    items: [],
    total: 0,
    loading: false,
    error: null,
  },
  reducers: {
    clearMembersError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMembers.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchMembers.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.members || action.payload;
        state.total = action.payload.total || state.items.length;
      })
      .addCase(fetchMembers.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(deleteMember.fulfilled, (state, action) => {
        state.items = state.items.filter((m) => m.id !== action.payload);
        state.total -= 1;
      });
  },
});

export const { clearMembersError } = membersSlice.actions;
export default membersSlice.reducer;
